import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PatientCard = ({ patient, onEdit, onDelete, onSchedule, onViewDetails }) => {
  const formatPhone = (phone) => {
    const numbers = phone?.replace(/\D/g, '');
    if (numbers?.length === 11) {
      return `(${numbers?.slice(0, 2)}) ${numbers?.slice(2, 7)}-${numbers?.slice(7)}`;
    }
    return phone;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Nunca';
    const date = new Date(dateString);
    return date?.toLocaleDateString('pt-BR');
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-soft hover:shadow-elevated transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <span className="text-base font-semibold text-primary">
              {patient?.name?.split(' ')?.map(n => n?.[0])?.join('')?.slice(0, 2)?.toUpperCase()}
            </span>
          </div>
          <div>
            <h3 className="font-semibold text-foreground">{patient?.name}</h3>
            <p className="text-xs text-muted-foreground">{patient?.email}</p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onViewDetails(patient)}
        >
          <Icon name="Eye" size={18} />
        </Button>
      </div>
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Phone" size={16} className="text-muted-foreground" />
          <span className="text-sm text-foreground">{formatPhone(patient?.phone)}</span>
          {patient?.whatsappEnabled && (
            <Icon name="MessageCircle" size={14} className="text-success" />
          )}
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Calendar" size={16} className="text-muted-foreground" />
          <span className="text-sm text-foreground">Última visita: {formatDate(patient?.lastVisit)}</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Activity" size={16} className="text-muted-foreground" />
          <span className="text-sm text-foreground">{patient?.totalSessions} sessões realizadas</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="DollarSign" size={16} className="text-muted-foreground" />
          <span className="text-sm font-medium text-foreground">
            R$ {patient?.defaultSessionValue?.toFixed(2)?.replace('.', ',')} por sessão
          </span>
        </div>
      </div>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onSchedule(patient)}
          iconName="Calendar"
          iconPosition="left"
          fullWidth
        >
          Agendar
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onEdit(patient)}
          iconName="Edit"
          iconPosition="left"
          fullWidth
        >
          Editar
        </Button>
        <Button
          variant="outline"
          size="icon"
          onClick={() => onDelete(patient)}
        >
          <Icon name="Trash2" size={18} className="text-destructive" />
        </Button>
      </div>
    </div>
  );
};

export default PatientCard;